import type { FieldType, Theme } from "@structurify/shared-types";

interface Props {
  type: FieldType;
  theme: Theme;
  size?: number;
}

export function TypeGlyph({ type, theme, size = 11 }: Props) {
  const c = theme.inkMute;
  const w = size;
  const h = size;
  switch (type) {
    case "date":
      return (
        <svg width={w} height={h} viewBox="0 0 12 12">
          <rect x="1.5" y="2.5" width="9" height="8" rx="1" fill="none" stroke={c} />
          <line x1="1.5" y1="5" x2="10.5" y2="5" stroke={c} />
          <line x1="4" y1="1" x2="4" y2="3" stroke={c} />
          <line x1="8" y1="1" x2="8" y2="3" stroke={c} />
        </svg>
      );
    case "currency":
      return (
        <svg width={w} height={h} viewBox="0 0 12 12">
          <text x="6" y="9.5" fontSize="10" textAnchor="middle" fill={c} fontFamily="ui-monospace, monospace">
            $
          </text>
        </svg>
      );
    case "phone":
      return (
        <svg width={w} height={h} viewBox="0 0 12 12">
          <path d="M3 2 L4.5 3.5 L3.5 5 Q4.5 7 7 8 L8.5 7 L10 8.5 L9 10 Q5 10 2.5 7 Q1 4 3 2 Z" fill="none" stroke={c} />
        </svg>
      );
    case "address":
      return (
        <svg width={w} height={h} viewBox="0 0 12 12">
          <path d="M6 1.5 L10.5 5 L10.5 10.5 L7.5 10.5 L7.5 7.5 L4.5 7.5 L4.5 10.5 L1.5 10.5 L1.5 5 Z" fill="none" stroke={c} />
        </svg>
      );
    case "long_text":
      return (
        <svg width={w} height={h} viewBox="0 0 12 12">
          <line x1="2" y1="3" x2="10" y2="3" stroke={c} />
          <line x1="2" y1="6" x2="10" y2="6" stroke={c} />
          <line x1="2" y1="9" x2="7" y2="9" stroke={c} />
        </svg>
      );
    case "category":
      return (
        <svg width={w} height={h} viewBox="0 0 12 12">
          <circle cx="6" cy="6" r="3.5" fill="none" stroke={c} />
        </svg>
      );
    default:
      return (
        <svg width={w} height={h} viewBox="0 0 12 12">
          <line x1="2" y1="6" x2="10" y2="6" stroke={c} />
        </svg>
      );
  }
}
